import React from 'react'
import EssayListBlock from 'pages/ApplicationDetailsPage/components/Essay/components/EssayListBlock/EssayListBlock'
import { ReactComponent as CrossIcon } from 'assets/icons/cross.svg'
import s from './EssayListSidePanel.module.scss'

const EssayListSidePanel = ({
	open,
	items = [],
	activeEssayId,
	loading = false,
	onSelect,
	onClose,
}) => {
	if (!open) return null

	return (
		<aside className={s.panel} aria-label="All essays">
			<header className={s.head}>
				<h3 className={s.title}>All essays</h3>
				<button
					type="button"
					className={s.closeBtn}
					onClick={onClose}
					aria-label="Close list panel"
				>
					<CrossIcon />
				</button>
			</header>
			{loading ? <p className={s.loading}>Loading...</p> : null}
			<div className={s.list}>
				<EssayListBlock
					type="list"
					items={items}
					activeEssayId={activeEssayId}
					onSelect={onSelect}
				/>
			</div>
		</aside>
	)
}

export default EssayListSidePanel
